import React, { useEffect, useState } from 'react';
import { CheckCircle2, X } from 'lucide-react';
const CITIES = ['Buenos Aires', 'Córdoba', 'Rosario', 'Mendoza', 'La Plata', 'San Miguel de Tucumán', 'Mar del Plata', 'Salta', 'Santa Fe', 'San Juan', 'Resistencia', 'Neuquén', 'Santiago del Estero', 'Corrientes'];
const NAMES = ['María', 'Juan', 'Sofía', 'Lucas', 'Valentina', 'Mateo', 'Camila', 'Benjamín', 'Lucía', 'Martín', 'Florencia', 'Joaquín'];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [data, setData] = useState({
    name: '',
    city: ''
  });
  useEffect(() => {
    const initialTimeout = setTimeout(() => showNewNotification(), 5000);
    return () => clearTimeout(initialTimeout);
  }, []);
  const showNewNotification = () => {
    setData({
      name: NAMES[Math.floor(Math.random() * NAMES.length)],
      city: CITIES[Math.floor(Math.random() * CITIES.length)]
    });
    setIsVisible(true);
    setTimeout(() => {
      setIsVisible(false);
      setTimeout(showNewNotification, Math.random() * 10000 + 10000);
    }, 5000);
  };
  if (!isVisible) return null;
  return <div className="fixed bottom-4 left-4 z-50 animate-slide-up md:max-w-sm w-[calc(100%-2rem)]" data-id="element-42">
      <div className="bg-white rounded-xl shadow-lg border border-brand-border border-l-4 border-l-brand-sage p-4 flex items-start gap-3 relative" data-id="element-43">
        <button onClick={() => setIsVisible(false)} className="absolute top-2 right-2 text-brand-brown-light/40 hover:text-brand-brown" data-id="element-44">
          <X size={14} data-id="element-45" />
        </button>
        <div className="bg-brand-sage-light rounded-full p-2 flex-shrink-0" data-id="element-46">
          <CheckCircle2 className="w-6 h-6 text-brand-sage" data-id="element-47" />
        </div>
        <div data-id="element-48">
          <p className="text-sm font-bold text-brand-brown" data-id="element-49">
            {data.name} de {data.city}
          </p>
          <p className="text-xs text-brand-brown-light mt-1" data-id="element-50">
            Compró el{' '}
            <span className="font-semibold text-brand-coral" data-id="element-51">
              Mega Pack Gimnasia Cerebral
            </span>
          </p>
          <p className="text-[10px] text-brand-brown-light/50 mt-1" data-id="element-52">
            Hace unos instantes
          </p>
        </div>
      </div>
    </div>;
}